import { ChatLogo } from "./ChatLogo";
import "../styles/chat-boot-splash.css";

type Props = {
  label: string;
  /** Mode chargement (barre) ou statut figé (login / erreur) */
  mode?: "loading" | "status";
  exiting?: boolean;
};

export function ChatBootSplash({ label, mode = "loading", exiting = false }: Props) {
  return (
    <div
      className={`chat-boot ${exiting ? "chat-boot--exiting" : ""}`}
      role="status"
      aria-live="polite"
      aria-busy={mode === "loading"}
    >
      <div className="chat-boot__glow chat-boot__glow--a" aria-hidden />
      <div className="chat-boot__glow chat-boot__glow--b" aria-hidden />
      <div className="chat-boot__mesh" aria-hidden />

      <div className="chat-boot__stage">
        <div className="chat-boot__mark">
          <span className="chat-boot__icon-wrap">
            <ChatLogo className="chat-boot__logo" size={88} splash />
          </span>
        </div>

        <p className="chat-boot__eyebrow">Aurélia</p>
        <h1 className="chat-boot__title">Chat</h1>

        <p className="chat-boot__label">{label}</p>

        {mode === "loading" ? (
          <div className="chat-boot__bar" aria-hidden>
            <span className="chat-boot__bar-fill" />
          </div>
        ) : (
          <div className="chat-boot__dots" aria-hidden>
            <span />
            <span />
            <span />
          </div>
        )}
      </div>
    </div>
  );
}
